import styled, { css } from 'styled-components';
import { regularWhite, fontWeightBold } from '../../../../ui-components/design-tokens';
import { device } from '../../../../ui-components/breakpoints';
import { playFocus } from 'app/ui-components/utils.styles';
import { PlayTextStyles } from 'app/ui-components/typography/PlayText/PlayText.styles';

export const ListItem = styled.li`
    display: inline-block;
    margin-top: -2px;
    margin-left: 0;
    letter-spacing: 0.5px;
    text-transform: uppercase;

    @media ${device.GteSmall} {
        display: block;
        float: left;
    }

    ${(props) =>
        props.type === 'search' &&
        css`
            @media ${device.GteSmall} {
                display: none;
            }
        `}
`;

export const Link = styled.a`
    ${PlayTextStyles}
    text-decoration: none;
    display: block;
    padding: 10px 8px;
    ${playFocus()}

    &:hover,
    &:active,
    &:visited {
        color: ${regularWhite};
    }

    &:hover {
        .no-touchevents && {
            text-decoration: underline;
        }
    }

    ${(props) =>
        props.isActive &&
        css`
            font-weight: ${fontWeightBold};
        `}

    @media ${device.GteMedium} {
        padding: 10px 15px;
    }
`;
